<template>
  <div class="appContent">
    <!-- 页面容器 -->

      <router-view />

     <!-- <router-view v-slot="{ Component }">
    <keep-alive>
      <component :is="Component"  v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <component :is="Component"  v-if="!$route.meta.keepAlive"/>
  </router-view>  -->
  </div>
</template>

<script>
export default {
  name: "mainContent",
  watch: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.appContent {
  width: 100vw;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  position: relative;
  
}
</style>